module.exports = __webpack_public_path__ + "img/h3.17a2540e.png";